import ApiService from '@/helpers/api.service';
import { Storage } from 'aws-amplify';
import moment from "moment";

const API = new ApiService();

const EVENT_ENDPOINT = '/events';

export const state = {
  events: [],
  eventPage: {
    totalRows: 0
  },
  attendees: [],
  attendeePage: {
    totalRows: 0
  },
  attendeesModal: [],
  attendeePageModal: {
    totalRows: 0
  },
  errors: null
}

export const mutations = {
  SET_EVENT_ERROR(state, errors){
    state.errors = errors;
  },
  UPDATE_EVENT_LIST(state, events){
    state.events = events;
  },
  UPDATE_EVENT_PAGE(state, pageInfo){
    state.eventPage = pageInfo;
    console.log(state.eventPage);
  },
  UPDATE_EVENT_ATTENDEES(state, attendees){
    state.attendees = attendees;
  },
  UPDATE_EVENT_ATTENDEES_PAGE(state, pageInfo){
    state.attendeePage = pageInfo;
    console.log(state.attendeePage);
  },
  UPDATE_EVENT_ATTENDEES_MODAL(state, attendeesModal){
    state.attendeesModal = attendeesModal;
  },
  UPDATE_EVENT_ATTENDEES_PAGE_MODAL(state, pageInfo){
    state.attendeePageModal = pageInfo;
    console.log(state.attendeePageModal);
  },
}

export const actions = {
  addAttendee(context, params){
    console.log(params);
    return new Promise((resolve, reject) => {
      API.post(`${EVENT_ENDPOINT}/add-attendee`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
            console.log("add attendee err");
          } else {
            resolve();
            console.log("add attendee resolve");
          }
        })
        .catch(({response}) => {
          context.commit('SET_EVENT_ERROR', response.data.errors);
        })
    });
  },
  getAttendee(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${EVENT_ENDPOINT}/get-attendee`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_EVENT_ATTENDEES_MODAL', data.message.rows);
            context.commit('UPDATE_EVENT_ATTENDEES_PAGE_MODAL', {
              totalRows: data.message.pageInfo.total
            });
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_EVENT_ERROR', response.data.errors);
          reject();
        });
    });
  },
  deleteAttendee(context, id){
    return new Promise((resolve, reject) => {
      API.post(`${EVENT_ENDPOINT}/attendee-delete`, {attendeeId: id})
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({response}) => {
          context.commit('SET_EVENT_ERROR', response.data.errors);
        })
    });
  },
  eventAttendee(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${EVENT_ENDPOINT}/attendee-list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_EVENT_ATTENDEES', data.message.rows);
            context.commit('UPDATE_EVENT_ATTENDEES_PAGE', {
              totalRows: data.message.pageInfo.total
            });
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_EVENT_ERROR', response.data.errors);
          reject();
        });
    });
  },
  updateEventItem(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${EVENT_ENDPOINT}/update`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({response}) => {
          context.commit('SET_EVENT_ERROR', response.data.errors);
        })
    });
  },
  deleteEventItem(context, id){
    return new Promise((resolve, reject) => {
      API.post(`${EVENT_ENDPOINT}/delete`, {eventId: id})
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({response}) => {
          context.commit('SET_EVENT_ERROR', response.data.errors);
        })
    });
  },
  getEvent(context, id){
    return new Promise((resolve, reject) => {
      API.post(`${EVENT_ENDPOINT}/info`, {id: id})
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({response}) => {
          context.commit('SET_EVENT_ERROR', response.data.errors);
        })
    });
  },
  eventList(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${EVENT_ENDPOINT}/list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_EVENT_LIST', data.message.rows);
            context.commit('UPDATE_EVENT_PAGE', {
              totalRows: data.message.pageInfo.total
            });
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_EVENT_ERROR', response.data.errors);
          reject();
        });
    });
  },
  createEventAPI(context, params){
    console.log(params);
    return new Promise((resolve, reject) => {
      API.post(`${EVENT_ENDPOINT}/create`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
            console.log("create event err");
          } else {
            resolve();
            console.log("create event resolve");
          }
        })
        .catch(({response}) => {
          context.commit('SET_EVENT_ERROR', response.data.errors);
        })
    });
  },
  uploadLogo(context, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg","jpeg","png","svg"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }
      var metadata =  {
        customPrefix: {
          public: ''
        },
        expires: moment().add(30, 'days').toDate(),
      }

      if(params.type == 'svg'){
        metadata['contentType'] = 'image/svg+xml';
      }
      Storage.put(`${params.folder}/${params.filename}`, params.base64, metadata)
        .then(stored => {
            console.log(">> Success",stored);
            resolve(stored.key);
        })
        .catch(err => {
            console.log(">> Err",err);
            reject(err);
        });
    });
  },
  removeUploadLogo(context, params){
    return new Promise((resolve, reject) => {
      console.log(">> Removing Item:",params);
      Storage.remove(`${params}`)
        .then(stored => {
            console.log(">> remove Success",stored);
            resolve(stored.key);
        })
        .catch(err => {
            console.log(">> remove Err",err);
            reject(err);
        });
    });
  }
}

export const getters = {}